import { LoadingOverlay } from "@mantine/core";

const ContainerLoadingOverlay = ({ visible, ...rest }: any) => {
  return (
    <LoadingOverlay
      visible={visible}
      zIndex={1000}
      overlayProps={{ blur: 2, radius: "20px" }}
      loaderProps={{ color: "#5c26ff" }}
      {...rest}
    />
  );
};

export default ContainerLoadingOverlay;
